import { useGetPage } from 'hooks/useGetPage';
import { pageIds } from 'utilities/constants';
import { ChangeEvent } from 'react';
import { Errors } from 'hooks/useFormValidation';
import InputComponent from 'components/inputComponent';
import Alert from 'components/alertComponent';
import { ReactComponent as InfoIcon } from 'assets/icons/info-gray.svg';

interface PasswordChangeFormProps {
  errors: Errors;
  passwordChangeError: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export const PasswordChangeForm: React.FC<PasswordChangeFormProps> = ({
  errors,
  passwordChangeError,
  onChange,
}) => {
  const { data: locale, loading } = useGetPage({
    locale: 'en',
    pageId: pageIds.MY_PROFILE,
  });

  if (loading && !locale) return null;

  return (
    <div className="flex flex-col gap-2.5">
      {passwordChangeError && (
        <div className="mb-2.5">
          <Alert type="warning" text={passwordChangeError} />
        </div>
      )}
      <div className="flex flex-col items-start">
        <label
          className="w-full text-base text-dark-gray font-semibold mb-2"
          htmlFor="currentPassword"
        >
          {locale?.securityAndPrivacy?.currentPassword}
          <span className="text-base font-bold text-clc-red">*</span>
        </label>
        <div className="w-full">
          <InputComponent
            type="password"
            name={'currentPassword'}
            label={locale?.securityAndPrivacy?.currentPassword}
            onChange={onChange}
            errorStatus={!!errors.currentPassword}
            errorMsgWithIcon={errors.currentPassword}
            noMarginBottom
            isShowErrorAfterTouched
          />
        </div>
      </div>
      <div className="flex flex-col items-start">
        <label
          className="w-full text-base text-dark-gray font-semibold mb-2"
          htmlFor="newPassword"
        >
          {locale?.securityAndPrivacy.newPassword}
          <span className="text-base font-bold text-clc-red">*</span>
        </label>
        <div className="w-full">
          <InputComponent
            testID="newPassword-input"
            type="password"
            name={'newPassword'}
            onChange={onChange}
            label={locale?.securityAndPrivacy.newPassword}
            errorStatus={!!errors.newPassword}
            errorMsgWithIcon={errors.newPassword}
            noMarginBottom
            isShowErrorAfterTouched
          />
        </div>
        {!errors.newPassword && (
          <div className="mt-1 flex items-center gap-[5px]">
            <InfoIcon className="shrink-0" />
            <p className="text-xs text-med-gray-3 font-semibold">
              {locale?.securityAndPrivacy?.passwordNotValid}
            </p>
          </div>
        )}
      </div>
      <div className="flex flex-col items-start">
        <label
          className="w-full text-base text-dark-gray font-semibold mb-2"
          htmlFor="confirmPassword"
        >
          {locale?.securityAndPrivacy?.confirmPassword}
          <span className="text-base font-bold text-clc-red">*</span>
        </label>
        <div className="w-full">
          <InputComponent
            testID="confirmPassword-input"
            type="password"
            name={'confirmPassword'}
            label={locale?.securityAndPrivacy?.confirmPassword}
            onChange={onChange}
            errorStatus={!!errors.confirmPassword}
            errorMsgWithIcon={errors.confirmPassword}
            noMarginBottom
            isShowErrorAfterTouched
          />
        </div>
      </div>
    </div>
  );
};
